import plural from 'plural-ru'

export default function(number, ...forms) {
  return plural(number, ...forms)
}